import React from 'react'
import RToggle from 'react-toggle'
import 'react-toggle/style.css'
import cx from 'classnames'
import style from './style.module.css'
import { ToggleValue } from 'components/Admin/Shared/Toggle'

const Toggle = ({
  id,
  className,
  state,
  onChange,
  ...props
}: {
  id?: string
  className?: string
  state?: ToggleValue
  onChange: (state: ToggleValue) => void
  props?: any
}) => {
  return (
    <RToggle
      id={id}
      icons={false}
      {...props}
      onChange={onChange}
      className={cx(style.wrapper, className)}
      checked={state === ToggleValue.PUBLIC ? true : false}
    />
  )
}

export default Toggle
